/** Cor de cada área do Heimdall, sempre com tokens de cor. */
export const tons = {
  vinho: 'bg-primary/10 text-primary',
  ambar: 'bg-chart-sem-warning/15 text-chart-sem-warning',
  azul: 'bg-chart-sem-info/15 text-chart-sem-info',
  violeta: 'bg-chart-sem-violet/20 text-chart-sem-violet',
  verde: 'bg-chart-sem-success/15 text-chart-sem-success',
  turquesa: 'bg-chart-sem-accent/15 text-chart-sem-accent',
  neutro: 'bg-muted text-muted-foreground',
} as const

export type Tom = keyof typeof tons
